<template>
    <footer class="bottom-footer">
        <div class="logo-row">
            <img class="footer-logo" :src="logo" alt="">
        </div>
        <div class="coop-row">
            <router-link :to="{name: 'coop'}" class="coop-btn">{{lang.coop}}</router-link>
        </div>
        <dl :class="['coll-row', 'address-row', addressSwitch?'active':'']">
            <dt @click="toggleColl('address')">
                <span>{{lang.companyAddress}}</span>
                <span class="font-icon">{{addressSwitch ? '-' : '+'}}</span>
            </dt>
            <dd v-for="(address, index) in companyAddress" :key="index">
                <span>{{isCn?address.cnStr:address.enStr}}</span>
            </dd>
        </dl>
        <dl :class="['coll-row', 'wechat-row', wechatSwitch?'active':'']">
            <dt @click="toggleColl('wechat')">
                <span>{{lang.wechatService}}</span>
                <span class="font-icon">{{wechatSwitch ? '-' : '+'}}</span>
            </dt>
            <dd>
                <div v-for="(wechat, index) in wechatService" :key="index" class="code-area">
                    <img :src="wechat.other" alt="">
                    <span>{{isCn?wechat.cnStr:wechat.enStr}}</span>
                </div>
            </dd>
        </dl>
        <dl class="coll-row phone-row">
            <dt>
                <span>{{phoneTitle}}</span>
                <span style="text-align:right;">{{phoneChina}} ( {{lang.china}} )<br>{{phoneOversea}} ( {{lang.oversea}} )</span>
            </dt>
        </dl>
    </footer>
</template>

<script>
import logoSrc from '@/style/image/logo.png';
import getLang from '@/utils/main/lang';
import ajax from '@/utils/ajax';

export default {
    name: 'layout-foot',
    components: {
        // Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            linkSwitch: false,
            addressSwitch: false,
            wechatSwitch: false,
            logo: logoSrc,
            companyAddress: [],
            wechatService: [],
            phoneChina: '',
            phoneOversea: '',
            phoneTitle: '',
        };
    },
    mounted() {
        const self = this;
        ajax.get('/web/common/bottom_list.json', {}).then((result) => {
            this.companyAddress = result.data.companyAddress;
            const phoneArr = result.data.serviceHotLine;
            if (phoneArr[0]) {
                this.phoneTitle = this.isCn ? phoneArr[0].cnStr : phoneArr[0].enStr;
                this.phoneChina = phoneArr[0].other.split(' ')[0];
                this.phoneOversea = phoneArr[0].other.split(' ')[1];
            }
            this.wechatService = result.data.weChatService;
        }).catch(() => {});
        ajax.get('/web/common/logo.json', {}).then((result) => {
            if (result.data) {
                self.logo = result.data;
            }
        }).catch(() => {});
    },
    methods: {
        toggleColl(row) {
            this[`${row}Switch`] = !this[`${row}Switch`];
        },
        changeLang(lang) {
            if (window.localStorage) {
                window.localStorage.setItem('show-lang', lang);
            }
            this.$router.go(0);
        },
    },
};
</script>
<style lang="less" scoped>
    .bottom-footer {
        color: #fff;
        padding: 16px 15px 1px;
        font-size: 13px;
        a {
            color: #fff;
        }
    }
    .coll-row {
        dt {
            display: flex;
            justify-content: space-between;
            align-content: center;
            border-bottom: 1px solid #9B9B9B;
            line-height: 16px;
            padding-bottom: 8px;
            margin-bottom: 9px;
            .font-icon {
                font-size: 28px;
            }
        }
        dd {
            display: none;
            justify-content: space-between;
            align-content: center;
            color: #C1C1C1;
            font-size: 12px;
            a {
                color: #C1C1C1;
            }
            .font-icon {
                font-size: 12px;
            }
            &:last-child {
                border-bottom: 1px solid #9B9B9B;
                padding-bottom: 6px;
                margin-bottom: 6px;
            }
        }
        &.active dd {
            display: flex;
        }
    }
    .logo-row {
        padding-top: 2px;
        padding-bottom: 15px;
        text-align: center;
        img {
            width: 22px;
            height: 26px;
        }
    }
    .coop-row {
        text-align: center;
        padding-bottom: 22px;
        .coop-btn {
            border: 1px solid #fff;
            padding: 6px 22px;
            line-height: 16px;
            border-radius: 2px;
        }
    }
    .address-row dd {
        word-break: break-word;
        padding: 3px 0;
        line-height: 18px;
    }
    .wechat-row dd {
        justify-content: center;
        .code-area {
            width: 90px;
            // height: 60px;
            margin: 6px 18px;
            text-align: center;
            word-break: break-word;
            img {
                display: block;
                margin: 0 auto;
                width: 60px;
            }
        }
    }
    .phone-row dt {
        border: 0;
    }

</style>
